export const USERINFO = "userInfo"; //用户数据
export const TOKEN = "token"; //token
export const USER = "user"; //用户账号密码
export const ISIFRAME = "IsIframe"; //是否子页面
export const SYSTEMPARAM = "systemParam"; //系统参数
